import { useCollectionViewData } from '@shared/scenes/cards/collectionView/hooks/useCollectionViewData';

export function useCardListView(
  workflowTemplateId: string,
  viewTemplateId: string,
  workspaceId: number,
  baseNavigationPath: string,
) {
  return useCollectionViewData({
    workflowTemplateId,
    viewTemplateId,
    workspaceId,
    baseNavigationPath,
  });
}
